.<template>
        <v-row class="pa-0 mx-1">
            <v-col xs="10" sm="10" md="10" cols="10" class="pb-0 pr-0 mt-0 mb-0 d-flex column">
                <li class="ml-2 mr-2"></li>
                <label class="pa-0 prompt-24 d-flex align-center" v-if=!isExtra>{{ $t("message.doc."+evidenceDetail.name) }}</label>
                <label class="pa-0 prompt-24 d-flex align-center" v-else>{{ evidenceDetail.name }}</label>
            </v-col>
            <!--  Upload Transaction Payment Image -->
            <v-col xs="2" sm="2" md="2" cols="2" class="py-0 pt-3 d-flex flex-row-reverse align-center" v-if="is_picture">
                    <!-- wait upload -->
                    <v-btn
                        outlined
                        color="orange"
                        min-width="32"
                        height="32"
                        class="pa-0"
                        style="border-radius: 8px"
                        id="uploadBtn"
                        @click="uploadFile(elementKey, input)"
                        v-if="!this.input.show"
                        :disabled="this.input.show"
                    >
                        <v-icon color="orange" small> mdi-plus </v-icon>
                    </v-btn>
                    <!-- uploaded -->
                    <v-btn
                        outlined
                        color="#AFADB1"
                        min-width="32"
                        height="32"
                        class="pa-0"
                        style="border-radius: 8px; border-color: #afadb1"
                        id="uploadBtn"
                        v-if="this.input.show"
                        :disabled="true"
                    >
                        <v-icon color="orange" small> mdi-plus </v-icon>
                    </v-btn>

            </v-col>
            <!--  Upload Document pdf -->
            <v-col xs="2" sm="2" md="2" cols="2" class="py-0 pt-3 d-flex flex-row-reverse align-center" v-else>
                <!-- wait upload -->
                <v-btn
                    outlined
                    color="orange"
                    min-width="32"
                    height="32"
                    class="pa-0"
                    style="border-radius: 8px"
                    id="uploadBtn"
                    @click="uploadFile(elementKey, input)"
                    v-if="!this.input.show"
                    :disabled="this.input.show"
                >
                    <v-icon color="orange" small> mdi-plus </v-icon>
                </v-btn>
                <!-- uploaded -->
                <v-btn
                    outlined
                    color="#AFADB1"
                    min-width="32"
                    height="32"
                    class="pa-0"
                    style="border-radius: 8px; border-color: #afadb1"
                    id="uploadBtn"
                    v-if="this.input.show"
                    :disabled="true"
                >
                    <v-icon color="orange" small> mdi-plus </v-icon>
                </v-btn>
            </v-col>
            <!-- Document detail -->
            <v-col cols="12" sm="12" md="12" class="py-0 my-0" v-if=!isExtra>
                <div class="pa-0" v-if="evidenceCondition.preview" >
                    {{$t("message.doc.content_name_of_file")}} : {{ $t("message.doc."+evidenceCondition.preview) }} {{ $t("message.doc.suchAs") }}
                    {{ $t("message.doc."+evidenceDetail.example) }}
                </div>
            </v-col>
            <v-col cols="12" sm="12" md="12" class="py-0 my-0" v-else>
                <!-- <div class="pa-0" v-if="evidenceCondition.preview">
                    {{$t("message.doc.content_name_of_file")}} : {{ evidenceCondition.preview }} {{ $t("message.doc.suchAs") }}
                    {{ evidenceDetail.example }}
                </div> -->
                <div class="pa-0 pl-4">
                    {{  $t("message.doc.content_evidence_file_info") }}
                </div>
            </v-col>
            <v-col cols="12" sm="12" md="12" class="py-0 my-0">
                <!--  Upload Transaction Payment Image -->
                <input
                    v-if="is_picture"
                    type="file"
                    :id="elementKey"
                    style="display: none"
                    accept=".jpg, .jpeg, .png"
                    ref="input_picture"
                    @change="onChangeFile"
                    @click="$event.target.value = ''"
                />
                <!--  Upload Document pdf -->
                <input
                    type="file"
                    :id="elementKey"
                    style="display: none"
                    accept="application/pdf"
                    ref="input"
                    @change="onChangeFile"
                    @click="$event.target.value = ''"
                />
                <FileInput :appear="this.input" @deleteFile="deleteFile" />
            </v-col>
        </v-row>
</template>

<script>
import { uploadElementFile, validateUploadFile, validateUploadImageFile } from "@/utils/file";
import FileInput from "../fileElement/FileInput.vue";
import { dateTime } from "@/utils/date";
import * as services from "@/services";
import { locale } from "core-js";

export default {
    name: "UploadEvidenceFile",
    data: () => ({
        input: {
            show: false,
            color: "",
            fileName: "",
            fullFileName: "",
            file: null,
        },
        file: new FormData
    }),
    props: {
        elementKey: String,
        student_id: Number,
        evidenceDetail: Object,
        evidenceCondition: Object,
        is_picture: Boolean,
        isExtra:Boolean,
        studentFullNameTh: String,
        studentFullNameEn: String,
        locale: String
    },
    methods: {
        loadingUpdate(value) {
            this.$emit("loadingUpdate", value);
        },
        async confirmUploadFile(){
            try{
                this.loadingUpdate(1)
                const {
                    data: { data },
                } = await services.uploadFile(this.file, {
                    module: "ENROLL_STUDENT_EVIDENCE",
                    fileName: this.input.fullFileName,
                    student_id: this.student_id,
                    date: dateTime("YYYY-MM-DD"),
                });
                return data
            }
            catch(err){
                throw new err
            }
            finally{
                this.loadingUpdate(-1)
            }
        },
        deleteFile(bool, obj) {
            try {
                this.loadingUpdate(1)
                if (this.input.file != null && this.file != null) {
                    this.file = null;
                    this.$emit("updateUploadStatus", this.elementKey, false)
                }
                this.input.file = null;
                this.input.color = "";
                obj.show = bool;
            } finally{
                this.loadingUpdate(-1)
            }
        },
        async uploadFile(elem, input) {
            await uploadElementFile(elem, input);
        },
        async onChangeFile(e) {
            try {
                this.loadingUpdate(1)
                if(!this.is_picture){
                    await validateUploadFile(
                        e.target,
                        this.input,
                        this.evidenceCondition?.pattern,
                        this.evidenceCondition?.pattern_en,
                        "application/pdf",
                        this.studentFullNameTh,
                        this.studentFullNameEn,
                        this.locale
                    );
                }
                else{
                    await validateUploadImageFile(
                        e.target,
                        this.input,
                        ["image/jpg", "image/jpeg", "image/png"]
                    );
                }
                const file = e.target.files[0];
                if (file) {
                    const formData = new FormData();
                    formData.append("file", file);
                    this.file = formData;
                    this.$emit("updateUploadStatus", this.elementKey, true)
                    this.$emit("uploadComplete", this.input, null);
                }
            } finally{
                this.loadingUpdate(-1)
            }
        },
        changeFileName(oldVal, newVal) {
            if (!this.input?.fullFileName) return;

            const oldFileName = this.input.fullFileName;
            const newFileName = oldFileName.replace(oldVal, newVal);
            this.input.fullFileName = newFileName;
            this.input.fileName = newFileName;
            //if (this.input.fileName?.length > 25) this.input.fileName = this.input.fileName.substring(0, 25) + "...";
        },
    },
    watch: {
        locale(newVal, oldVal) {
            if (newVal !== oldVal) {
                const oldFileName = this.input.fullFileName;
                if (newVal !== 'th') {
                    const newFileName = oldFileName.replace(`${this.evidenceCondition?.pattern}`, `${this.evidenceCondition?.pattern_en}`);
                    this.input.fullFileName = newFileName;
                    this.changeFileName(this.studentFullNameTh, this.studentFullNameEn);
                } else {
                    const newFileName = oldFileName.replace(`${this.evidenceCondition?.pattern_en}`, `${this.evidenceCondition?.pattern}`);
                    this.input.fullFileName = newFileName;
                    this.changeFileName(this.studentFullNameEn, this.studentFullNameTh);
                }
            }
        },
        studentFullNameTh(newVal, oldVal) {
            this.changeFileName(oldVal, newVal);

        },
        studentFullNameEn(newVal, oldVal) {
            this.changeFileName(oldVal, newVal);
        },
    },
    components: { FileInput },
};
</script>

<style lang="scss" scoped>
li {
    list-style: none;
}
li:before {
    content: "·";
    font-size: 30px;
    vertical-align: 3px;
    line-height: 30px;
}
</style>
